import firebase from 'firebase';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentMonth: new Date().toISOString().split('-')[0] + '-' + new Date().toISOString().split('-')[1],
    draggingRecipe: null,
    services: null,
    searchRecipe: "",
    user: null
  },
  getters: {
    getCurrentMonth: function (state) {
      return state.currentMonth;
    },
    getServices: function (state) {
      return state.services;
    },
    getDraggingRecipe: function (state) {
      return state.draggingRecipe;
    },
    getSearchRecipe: function (state) {
      return state.searchRecipe;
    }
  },
  mutations: {
    setSearchRecipe: function (state, search) {
      state.searchRecipe = search;
    },
    putDraggingRecipe: function (state, recipe) {
      state.draggingRecipe = recipe;
    },
    setCurrentMonth: function (state, value) {
      state.currentMonth = value;
    },
    fillServices: function (state, services) {
      let orderedServices = services.sort((a, b) => {
        if (a.date > b.date) {
          return -1;
        } else {
          return 1;
        }
      })
      state.services = orderedServices;
    }
  },
  actions: {
    readServices({
      commit
    }) {
      firebase.firestore().collection('services').where('month', '==', this.state.currentMonth).onSnapshot(refs => {
        let services = [];
        refs.forEach(ref => {
          services.push(ref.data());
        });
        commit('fillServices', services);
      })
    },
    addRecipe({
      commit
    }, payload) {
      let newRecipe = {
        name: this.state.draggingRecipe.name,
        ordername: this.state.draggingRecipe.ordername,
        id: this.state.draggingRecipe.id,
        comments: 0,
        rating: 0,
      }
      firebase.firestore().collection("services").doc(payload.service).update({
        ['recipes.' + payload.type]: firebase.firestore.FieldValue.arrayUnion(newRecipe),
      }).then(() => {
        this.state.draggingRecipe = null;
      })
      console.log(payload);
    },
    confirmService({
      commit
    }, service) {
      firebase.firestore().collection('services').doc(service).update({
        editing: false
      });
    }
  },
})